export default __webpack_public_path__ + "static/media/Bg_waiting_room_mobile.1517cb48.png";